/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.1.2
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An optional value indicating the directional change of the maneuver (further clarifying type).
 * @export
 */
export const OsrmGuidanceModifier = {
  Uturn: "uturn",
  SharpRight: "sharp right",
  Right: "right",
  SlightRight: "slight right",
  Straight: "straight",
  SlightLeft: "slight left",
  Left: "left",
  SharpLeft: "sharp left",
} as const;
export type OsrmGuidanceModifier =
  (typeof OsrmGuidanceModifier)[keyof typeof OsrmGuidanceModifier];

export function instanceOfOsrmGuidanceModifier(value: any): boolean {
  for (const key in OsrmGuidanceModifier) {
    if (Object.prototype.hasOwnProperty.call(OsrmGuidanceModifier, key)) {
      if (
        OsrmGuidanceModifier[key as keyof typeof OsrmGuidanceModifier] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function OsrmGuidanceModifierFromJSON(json: any): OsrmGuidanceModifier {
  return OsrmGuidanceModifierFromJSONTyped(json, false);
}

export function OsrmGuidanceModifierFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OsrmGuidanceModifier {
  return json as OsrmGuidanceModifier;
}

export function OsrmGuidanceModifierToJSON(
  value?: OsrmGuidanceModifier | null,
): any {
  return value as any;
}

export function OsrmGuidanceModifierToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): OsrmGuidanceModifier {
  return value as OsrmGuidanceModifier;
}
